import React, { useEffect, useState } from "react";
import ContentPageTitle from "../../../../common/ContentPageTitle";
import { useManageCreateMenuItem } from "../../../../hooks/useManageCreateMenuItem";

import { useDispatch, useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { getRestaurantsList } from "../../../../features/reducers/restaurants";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import ProductSettings from "./ProductSettings";
import { Select } from "antd";

export default function ManageProduct(props) {
  const { business } = props;

  // Initiate action to get user's business list
  const user = useSelector((state) => state.user.user);

  const dispatch = useDispatch();
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(undefined);

  const productsList = useSelector((state) => {
    console.log("state", state);
    return state.restaurants.restaurantsList;
  });

  useEffect(() => {
    if (!business.id) {
      return;
    }

    dispatch(getRestaurantsList(business.id, selectedCategory));
  }, [business.id, selectedCategory, dispatch]);

  useEffect(() => {
    const getCategoriesList = async () => {
      try {
        if (!business.id) {
          return;
        }

        const APIURL = `/api/restaurant/dish/categories/${business.id}`;
        const res = await axiosWithAuth().get(APIURL);
        setCategoriesList(res.data.data || []);
      } catch (error) {
        console.log("Error getting categories: ", error);
      }
    };

    getCategoriesList();
  }, [business.id]);

  // Custom hook to manage the creation/deletion of business listing
  const hookData = {
    creatorID: business.id,
    dispatchAction: getRestaurantsList(business.id, selectedCategory),
    deleteItemAPI: `/api/restaurant/dish/${business.id}/dish`,
    user: user,
    itemType: "products",
    type: "product",
    modalData: {
      title: "Create New Product",
      fieldLabel: "Product Name",
    },
  };

  // const [modalComponent, CreateItemButton, ListComponent] =
  //   useMangeManagementItem(hookData);

  const [modalComponent, CreateItemButton, ListComponent] =
    useManageCreateMenuItem(hookData);

  return (
    <div id="product-page">
      <ContentPageTitle title="My Menu" icon="file-pen" />

      <div className="content-box">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <div style={{ marginBottom: 16 }}>
                  <Select
                    allowClear
                    placeholder="Filter by category"
                    style={{ minWidth: 260 }}
                    value={selectedCategory}
                    onChange={(value) => setSelectedCategory(value)}
                    options={categoriesList.map((category) => ({
                      value: category.id,
                      label: category.category,
                    }))}
                  />
                </div>

                <ListComponent
                  emptyMessage="Seems like you don't have a product listing."
                  btnText="Create New Product"
                  listItems={productsList}
                />

                <CreateItemButton btnText="Create New Product" />
              </>
            }
            exact
          />

          <Route
            path="/:id"
            element={<ProductSettings business={business} />}
            exact
          />
        </Routes>
      </div>

      {modalComponent}
    </div>
  );
}
